module.exports = new __parcel__URL__("404.3f789470.svg").toString();